export type Category = 'expression' | 'hat' | 'top' | 'background' | 'effect';

export interface DressItem {
  id: string;
  category: Category;
  name: string;
  emoji: string; // 아이템을 emoji로 표현
  imageWidth?: number; // OptimizeImage의 w prop 값
  layer: number; // 레이어 순서 (낮을수록 뒤에)
}

export interface SelectedItems {
  expression: DressItem | null;
  hat: DressItem | null;
  top: DressItem | null;
  background: DressItem | null;
  effect: DressItem | null;
}

export const CATEGORY_ORDER: Category[] = ['expression', 'top', 'hat', 'effect', 'background'];

export const CATEGORY_LABELS: Record<Category, string> = {
  expression: '표정',
  hat: '모자',
  top: '상의',
  background: '배경',
  effect: '이펙트',
};
